'use client'

const TopBar = () => {
    return (
        <>
            <div className=" flex flex-row h-8 justify-end items-center py-2 bg-white ">
                <button>

                </button>
            </div>
        </>
    )
}
export default TopBar